var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsentNotReceived(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 65.737 65.737",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.869.9C15.209.9.9 15.209.9 32.869c0 17.66 14.309 31.968 31.969 31.968 17.66 0 31.968-14.308 31.968-31.968S50.53.9 32.87.9zm0 57.75c-14.244 0-25.782-11.537-25.782-25.781 0-14.244 11.538-25.782 25.782-25.782s25.78 11.538 25.78 25.782-11.536 25.78-25.78 25.78zm13.122-33.8a1.548 1.548 0 000-2.19l-2.913-2.914a1.548 1.548 0 00-2.191 0l-8.018 8.018-8.018-8.018a1.548 1.548 0 00-2.192 0l-2.913 2.913a1.548 1.548 0 000 2.192l8.018 8.018-8.018 8.018a1.548 1.548 0 000 2.191l2.913 2.913a1.548 1.548 0 002.192 0l8.018-8.018 8.018 8.018a1.548 1.548 0 002.191 0l2.913-2.913a1.548 1.548 0 000-2.191l-8.018-8.018 8.018-8.018z",
    fill: "#F9423B",
    fillRule: "nonzero",
    stroke: "#3C3C3B",
    strokeWidth: 1.8
  })));
}
export default SvgConsentNotReceived;